module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('header', {
    staticClass: "header",
    class: {
      'notLogin': !_vm.userName || _vm.unionLoginFailed
    }
  }, [_c('div', {
    staticClass: "header-wrapper"
  }, [_vm._m(0), _c('div', {
    attrs: {
      "id": "login_info"
    }
  }, [(!_vm.userName) ? _c('div', {
    staticClass: "unsigned"
  }, [_c('li', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('a', {
    class: {
      on: _vm.loginShown
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.toggleLoginPane
    }
  }, [_vm._v("登录")]), (!_vm.userName) ? _c('Login', {
    attrs: {
      "visible": _vm.loginShown,
      "system": "pcw_i360",
      "types": "normal",
      "reload": false,
      "redirect": "/login/doAuth"
    }
  }) : _vm._e()], 1)]) : _vm._e(), _c('div', {
    staticClass: "nav-right",
    staticStyle: {
      "float": "right"
    }
  }, [(!_vm.userName) ? _c('a', {
    attrs: {
      "href": "/present",
      "target": "_blank"
    }
  }, [_vm._v("产品介绍 ")]) : _vm._e(), _c('a', {
    attrs: {
      "href": "https://fenxi.360.cn/help",
      "target": "_blank"
    }
  }, [_vm._v("帮助中心")]), _c('a', {
    attrs: {
      "href": "https://fenxi.360.cn/help/contact",
      "target": "_blank"
    }
  }, [_vm._v("联系我们")]), (!!_vm.userName) ? [_c('span', [_vm._v("|")]), _c('a', {
    attrs: {
      "href": 'http://i.360.cn/?u=' + _vm.userName,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.userName))]), _c('a', {
    staticClass: "logout",
    attrs: {
      "href": "/login/exit"
    }
  }, [_vm._v("退出")])] : _vm._e()], 2)]), (!!_vm.userName && !_vm.unionLoginFailed) ? _c('ul', {
    staticClass: "nav"
  }, [(_vm.userName && _vm.domainList.length) ? _c('li', [_c('DomainSelect', {
    attrs: {
      "label": ""
    },
    on: {
      "change": _vm.onDomainChange
    }
  })], 1) : _vm._e(), (_vm.domainList.length === 0) ? _c('li', [_c('a', [_vm._v("网站分析")])]) : _vm._e(), _c('li', [_c('router-link', {
    attrs: {
      "to": "/app"
    }
  }, [_vm._v("应用推广")])], 1), _c('li', {
    directives: [{
      name: "reddot",
      rawName: "v-reddot",
      value: (_vm.settingReddot),
      expression: "settingReddot"
    }]
  }, [_c('router-link', {
    attrs: {
      "to": "/setting"
    }
  }, [_vm._v("设置中心")])], 1)]) : _vm._e()])]), _vm._t("default")], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "logo"
  }, [_c('a', {
    attrs: {
      "href": "/web/overview"
    }
  }, [_vm._v("website")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-048dc5e4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-048dc5e4!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/navbar.vue
// module id = 707
// module chunks = 0